<dw-message [message]="message"></dw-message>

<div dwRow>
    <div dwCol="12">
        <label class="label">Rejected Notes</label>
        <textarea id="notes" class="form-control" rows="5" [(ngModel)]="rejectedNotes"></textarea>
    </div>
</div>

